import { SolIcon } from '@sol/icons';
import { ObjectTools } from '../../tools/object-tools';
import { SolShortcut } from '../../services/shortcut.service';
import { BrowserTools } from '../../tools/browser-tools';
import { ShortcutTools } from '../../tools/shortcut-tools';

export interface SolShortcutItem {
  icon?: SolIcon;
  text?: string;
}

export class SolShortcutView {
  private constructor(
    public readonly shortcut: SolShortcut | undefined,
    public readonly items: SolShortcutItem[],
  ) {}

  public static of(): SolShortcutView {
    return new SolShortcutView(undefined, []);
  }

  public withShortcut(shortcut: SolShortcut | undefined): SolShortcutView {
    return this.copy({ shortcut }).recalculate();
  }

  private recalculate(): SolShortcutView {
    const items: SolShortcutItem[] = [];
    if (this.shortcut) {
      if (this.shortcut.ctrl) {
        if (BrowserTools.isMac()) {
          items.push({ icon: SolIcon.key_command });
        } else {
          items.push({ text: 'Ctrl' });
        }
      }
      if (this.shortcut.alt) {
        items.push({ text: 'Alt' });
      }
      if (this.shortcut.shift) {
        items.push({ icon: SolIcon.key_shift });
      }

      const key = this.shortcut.key;
      if (key === ' ') {
        items.push({ icon: SolIcon.key_space });
      } else if (key === 'ArrowUp') {
        items.push({ icon: SolIcon.arrow_up });
      } else if (key === 'ArrowDown') {
        items.push({ icon: SolIcon.arrow_down });
      } else if (key === 'ArrowLeft') {
        items.push({ icon: SolIcon.arrow_left });
      } else if (key === 'ArrowRight') {
        items.push({ icon: SolIcon.arrow_right });
      } else if (key !== '') {
        const text = ShortcutTools.toDisplayName(key);
        items.push({ text });
      }
    }
    return this.copy({ items });
  }

  private copy(props: Partial<SolShortcutView>): SolShortcutView {
    return ObjectTools.copy<SolShortcutView>(this, props);
  }
}
